/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const tokensSchema = z
	.object({
		access: z.string(),
		refresh: z.string(),
	})
	.describe("Сериализатор вывода токена - для документации.");
